import { render } from "./RoleSettingRight.vue?vue&type=template&id=5c49ad40&scoped=true"
import script from "./RoleSettingRight.vue?vue&type=script&lang=js"
export * from "./RoleSettingRight.vue?vue&type=script&lang=js"

import "./RoleSettingRight.vue?vue&type=style&index=0&id=5c49ad40&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c49ad40"]])

export default __exports__